import request from '@src/utils/request'
import type { Response } from '@src/utils/request'
import { fetcher } from '@src/utils/fetcher'

/**
 * 用户登录参数
 * username : 用户名
 * password : 密码
 * acceptedTerms : 是否接受用户协议
 * loginType : 用户登录类型
 */
export type LoginParam = {
	username?: string
	password?: string
	acceptedTerms?: boolean
	loginType?: string
}

/**
 * 用户登录
 * @param body
 */
export async function login(body: LoginParam): Promise<Response> {
	return fetcher('/user/login', 'POST', { body: body })
}

/**
 * 用户登出
 */
export async function loginOut() {
	return fetcher(`/user/logout`, 'GET')
}
